/**
 * Serializes a stack entry to a colon-delimited string.
 * Trailing empty AI-chat fields are dropped so stack entries without AI chat
 * stay as 4 fields (the original format).
 *
 * @param {{ accountId: String, boardId: String, cardId: String, tab?: String, aichat?: String, showingHistory?: Boolean }} entry
 * @returns {String}
 */
export const serializeStackEntry = (entry) => {
  const parts = [entry.accountId, entry.boardId, entry.cardId, entry.tab || 'description'];
  if (entry.aichat) parts.push(entry.aichat);
  if (entry.aichat && entry.showingHistory) parts.push('1');
  return parts.join(':');
};
